import { buyRequestsPath } from '@/lib/buyRequestTabs';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ClipboardList } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CreateBuyRequestDialog from '@/components/buyer/CreateBuyRequestDialog';
import { useFeatureRegistration, type FeatureMeta } from '@/contexts/FeatureRegistryContext';
import { saveCardOutcome } from '@/lib/chatCards';
import type { BuyRequestProposal } from './streamChat';

export const FEATURE_META: FeatureMeta = {
  id: 'chat-buy-request',
  label: 'Make a Buy Request from chat',
  description:
    'Tell Ask Cannafax what you need and a card opens the Make a Buy Request form with your sentence already read, ready to post.',
  triggerType: 'action',
  personas: ['buyer', 'buyer_seller', 'seller'],
};

/** The model only proposes; the user reviews in the real form and posts there. */
export function ChatBuyRequestCard({ proposal, threadId }: { proposal: BuyRequestProposal; threadId?: string | null }) {
  useFeatureRegistration(FEATURE_META);
  const [open, setOpen] = useState(false);
  const [posted, setPosted] = useState(proposal.outcome?.state === 'done');

  return (
    <div className="mt-2 rounded-lg border bg-card p-3 text-sm">
      <div className="flex items-start gap-2">
        <ClipboardList className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
        <p className="min-w-0 flex-1">{proposal.text}</p>
      </div>
      <div className="mt-3 flex items-center justify-end gap-2">
        {posted ? (
          <span className="inline-flex items-center gap-1.5 text-muted-foreground">
            <CheckCircle2 className="h-4 w-4" /> Posted ·{' '}
            <Link to={buyRequestsPath('mine')} className="underline underline-offset-2">See buy requests</Link>
          </span>
        ) : (
          <Button size="sm" onClick={() => setOpen(true)}>Review and post</Button>
        )}
      </div>
      <CreateBuyRequestDialog
        open={open}
        onOpenChange={setOpen}
        initialText={proposal.text}
        onPosted={() => { setPosted(true); void saveCardOutcome(threadId, proposal.cardId, { state: 'done' }); }}
      />
    </div>
  );
}
